import {
  CalendarCheck, BookOpen, HandsPraying, Star, Images,
  ChatCircleDots, Info, CheckCircle, RadioButton, IdentificationCard, ClipboardText, MusicNotes,
} from "@phosphor-icons/react";

export const PARENT_MENU = [
  { key: "laporan", label: "Laporan", icon: ClipboardText, path: "/laporan", color: "bg-emerald-100 text-emerald-600" },
  { key: "jadwal", label: "Jadwal Belajar", icon: CalendarCheck, path: "/jadwal", color: "bg-rose-100 text-rose-600" },
  { key: "absensi", label: "Absensi", icon: CheckCircle, path: "/absensi", color: "bg-green-100 text-green-600" },
  { key: "hafalan", label: "Hafalan & Capaian", icon: BookOpen, path: "/hafalan", color: "bg-amber-100 text-amber-600" },
  { key: "perkembangan", label: "Predikat", icon: Star, path: "/perkembangan", color: "bg-yellow-100 text-yellow-600" },
  { key: "galeri", label: "Galeri", icon: Images, path: "/galeri", color: "bg-purple-100 text-purple-600" },
  { key: "chat", label: "Chat Guru", icon: ChatCircleDots, path: "/pesan", color: "bg-sky-100 text-sky-600" },
  { key: "radio", label: "Kajian Parenting", icon: RadioButton, path: "/radio", color: "bg-indigo-100 text-indigo-600" },
  { key: "info", label: "Info", icon: Info, path: "/info", color: "bg-cyan-100 text-cyan-600" },
  { key: "profil-anak", label: "Profil Anak", icon: IdentificationCard, path: "/perkembangan", color: "bg-lime-100 text-lime-600" },
];
